import React from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ScreenShell } from '../components/ScreenShell';
import { ProgressHeader } from '../components/ui/ProgressHeader';
import { StepChildName } from './quiz/StepChildName';
import { StepAge } from './quiz/StepAge';
import { StepInterests } from './quiz/StepInterests';
import { StepPersonality } from './quiz/StepPersonality';
import { StepPriorities } from './quiz/StepPriorities';
import { StepContext } from './quiz/StepContext';
import { StepPersonalTouch } from './quiz/StepPersonalTouch';
import type { PersonalizationProfile } from '../types/profile';
export const TOTAL_STEPS = 7;
interface QuizFlowProps {
  step: number;
  profile: PersonalizationProfile;
  update: (patch: Partial<PersonalizationProfile>) => void;
  customInterest: string;
  onCustomInterestChange: (value: string) => void;
  onNext: () => void;
  onBack: () => void;
}
export function QuizFlow({
  step,
  profile,
  update,
  customInterest,
  onCustomInterestChange,
  onNext,
  onBack
}: QuizFlowProps) {
  const shared = {
    profile,
    update,
    onNext
  };
  const steps: Record<number, React.ReactNode> = {
    1: <StepChildName {...shared} data-id="element-164" data-mp="3evh2jjlktvxi" />,
    2: <StepAge {...shared} data-id="element-165" data-mp="3svrvcs6g5klb" />,
    3: <StepInterests {...shared} customInterest={customInterest} onCustomInterestChange={onCustomInterestChange} data-id="element-166" data-mp="3suqjilhlwu2j" />,
    4: <StepPersonality {...shared} data-id="element-167" data-mp="3nuvvqqt4oklp" />,
    5: <StepPriorities {...shared} data-id="element-168" data-mp="306cngba2w7tm" />,
    6: <StepContext {...shared} data-id="element-169" data-mp="307dvs7zpmg7n" />,
    7: <StepPersonalTouch {...shared} data-id="element-170" data-mp="2v8b2fkt3dyfi" />
  };
  return <ScreenShell data-id="element-171" data-mp="2v9m6zmud3a7o">
      <ProgressHeader step={step} total={TOTAL_STEPS} onBack={onBack} data-id="element-172" data-mp="2v5ydgnox2nsy" />
      <AnimatePresence mode="wait" data-id="element-173" data-mp="39xpampkxm9tb">
        <motion.div key={step} initial={{
        opacity: 0,
        x: 24
      }} animate={{
        opacity: 1,
        x: 0
      }} exit={{
        opacity: 0,
        x: -24
      }} transition={{
        duration: 0.32,
        ease: [0.22, 1, 0.36, 1]
      }} className="flex flex-1 flex-col" data-id="element-174" data-mp="39yqrxbsjjsjh">
          {steps[step]}
        </motion.div>
      </AnimatePresence>
    </ScreenShell>;
}